import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold mb-8 text-center">Privacy Policy</h1>
          <p className="text-muted-foreground mb-8 text-center">Last updated: September 12, 2025</p>
          
          <div className="prose prose-lg max-w-none space-y-8">
            <section>
              <h2 className="text-2xl font-semibold mb-4">Who we are</h2>
              <p>
                Frosted Cake Art LLC ("we," "us," "our") operates https://www.frostedcakeart.com and provides custom cake services in Greater Cleveland & Northeast Ohio. This Privacy Policy explains what we collect and how we use it.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">Information we collect</h2>
              
              <h3 className="text-xl font-medium mb-3">Information you provide:</h3>
              <p className="mb-4">
                Name, email, phone, event date/venue/servings, design notes, messages, and any photos you share.
              </p>

              <h3 className="text-xl font-medium mb-3">Payments:</h3>
              <p className="mb-4">
                We may view payment confirmations, but full card/bank data is handled by your chosen provider (Venmo, PayPal, Credit/Debit Card, Cash) under their policies.
              </p>

              <h3 className="text-xl font-medium mb-3">Automatic data:</h3>
              <p className="mb-4">
                IP address, device/browser, pages visited, time on site, and similar analytics via Google Analytics (cookies may be used).
              </p>

              <h3 className="text-xl font-medium mb-3">Security/anti-spam & email delivery:</h3>
              <p className="mb-4">
                Cloudflare Turnstile (bot protection) and Resend & SMTP Gateway (email sending) may receive technical data needed to operate their services.
              </p>

              <h3 className="text-xl font-medium mb-3">Embedded content:</h3>
              <p>
                Services like Instagram, YouTube, or Maps may place their own cookies.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">How we use information</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>Respond to inquiries/quotes, schedule and fulfill orders, arrange delivery/pickup.</li>
                <li>Operate, maintain, and improve the website; prevent spam/fraud; ensure security.</li>
                <li>With permission, showcase photos/testimonials of our work (you can opt out anytime).</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">Sharing of information</h2>
              <p className="mb-4">
                We do not sell your personal information. We share it only with:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Service providers (hosting, email, analytics, payment/anti-spam) bound by agreements to use data solely to provide services to us.</li>
                <li>Legal/compliance if required by law or to protect rights, safety, and security.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">Data retention</h2>
              <p>
                Inquiry and order records are kept as needed for business, legal, and tax purposes. Analytics/log data may be kept for shorter periods where feasible.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">Your Choices & Rights</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Access/Update/Delete:</strong> Email fcabakery@gmail.com to request a copy, correction, or deletion of information.</li>
                <li><strong>Marketing opt-out:</strong> Use any unsubscribe instructions or email us.</li>
                <li><strong>Cookies:</strong> Adjust your browser settings to limit or block cookies.</li>
                <li><strong>Photo usage:</strong> Email us to opt out of portfolio/social sharing of your order photos.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">Security</h2>
              <p>
                We use reasonable administrative, technical, and physical safeguards. No method of transmission or storage is 100% secure.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">Changes to This Policy</h2>
              <p>
                We may update this policy from time to time. The "Last updated" date reflects the most recent changes.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">Contact</h2>
              <div className="space-y-2">
                <p><strong>Frosted Cake Art LLC</strong></p>
                <p>Email: fcabakery@gmail.com • Phone: 216-571-8440</p>
                <p>Mail: 504 Manor Brook Dr, Chagrin Falls, OH 44022</p>
              </div>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;